"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CYCLIC_TIMESERIES = exports.POPULATION_EVENTS = exports.TRAINING = void 0;
exports.TRAINING = 'training';
exports.POPULATION_EVENTS = 'population-events';
exports.CYCLIC_TIMESERIES = 'cyclic-timeseries';
//# sourceMappingURL=datapool.js.map